import classnames from 'clsx';
import React from 'react';

import CircleIcon from '@swf/core/assets/icons/circle.svg';
import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import { Icon } from '@swf/sports/components';

import { TXTWCL_Close } from './Message.messages.json';
import styles from './Message.scss';

interface Props {
  type: 'ERROR' | 'BLUE';
  isAutoDismissible?: boolean;
  message: JSX.Element;
  dismissCallback?: () => void;
}

const Message: React.FC<Props> = ({
  type,
  isAutoDismissible = false,
  message,
  dismissCallback
}) => {
  const { formatMessage } = useRegulatoryIntl();

  return (
    <li
      role="alert"
      className={classnames(styles.message, {
        [styles.error]: type === 'ERROR',
        [styles.blue]: type === 'BLUE'
      })}
    >
      <Icon name="error" size="x2" className={styles.warningIcon} />

      <span className={styles.text}>{message}</span>
      {!!dismissCallback && (
        <button
          type="button"
          onClick={dismissCallback}
          title={formatMessage(TXTWCL_Close)}
          className={styles.closeButton}
        >
          <Icon name="close-medium" size="lg" />
          {isAutoDismissible && <CircleIcon className={styles.dismissProgress} />}
        </button>
      )}
    </li>
  );
};

export default Message;
